const benefits = [
  { icon: '👥', title: 'Manage Subscribers' },
  { icon: '🚚', title: 'Simplify Deliveries' },
  { icon: '🔄', title: 'Manage Subscriptions' },
  { icon: '📋', title: 'Track Orders' },
  { icon: '✉️', title: 'Email Notifications' },
  { icon: '📈', title: 'Grow Your Dairy' },
]

export default function TrustBenefits() {
  return (
    <section className="mf-section mf-trust">
      <div className="mf-container">
        <h2 className="mf-section-title mf-reveal">Built for Modern Dairy Businesses</h2>
        <p className="mf-section-subtitle mf-reveal">
          Everything you need to run your dairy efficiently, all in one platform.
        </p>

        <div className="mf-trust-grid">
          {benefits.map((b, i) => (
            <div key={i} className="mf-trust-card mf-reveal" style={{ transitionDelay: `${i * 0.07}s` }}>
              <div className="mf-trust-icon">{b.icon}</div>
              <h4>{b.title}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
